import React, { useEffect, useRef, useState } from "react";
import Loader from "./Loader";
import Axios from "axios";
import { api_url } from "../../config";

/*
  Recherche d'une commune par code postal (API `cities?postalCode=`), puis
  sélection dans la liste des résultats. Le libellé est relié au champ, l'erreur
  est identifiée et annoncée, les résultats sont des boutons (clavier).
*/
const PostalCode = ({
  value,
  updateData,
  location,
  name = "cityId",
  id = "postalCodeSearch",
  inputLabel = "",
  hint = null,
  error = {},
  disabled = false,
  margin = "my-5",
  debounceMs = 800,
  autoFocus = false,
}) => {
  const [cpInp, setCpInp] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [results, setResults] = useState([]);
  const [selectedText, setSelectedText] = useState("Code postal");
  const debounceRef = useRef(null);

  const errorMessage = error && error[name] ? error[name] : "";
  const hintId = id + "-hint";
  const errorId = id + "-error";
  const describedBy =
    [hint ? hintId : "", errorMessage ? errorId : ""].filter(Boolean).join(" ") || undefined;

  useEffect(() => {
    if (location) {
      setSelectedText(location.postalCode + " - " + location.name);
    }
  }, [location]);

  useEffect(() => {
    clearTimeout(debounceRef.current);
    if (cpInp.length === 5) {
      debounceRef.current = setTimeout(getLocation, debounceMs);
    }
    return () => clearTimeout(debounceRef.current);
  }, [cpInp]); // eslint-disable-line react-hooks/exhaustive-deps

  function getLocation() {
    setIsLoading(true);
    setResults([]);
    Axios.get(api_url + "cities?postalCode=" + cpInp)
      .then((res) => {
        setResults(res.data);
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
  }

  function updateSearch(next) {
    if ((next.length <= 5 && /^\d+$/.test(next)) || next.length === 0) {
      setCpInp(next);
    }
  }

  function changeData(res) {
    updateData({ target: { name: name, value: res.id } });
    setSelectedText(
      res.postalCode +
        " - " +
        res.townName +
        (res.locationName ? " - " + res.locationName : "")
    );
  }

  return (
    <div className={"form-group " + margin}>
      <label className="d-block control-label" htmlFor={id}>
        {inputLabel}
      </label>
      {hint && (
        <div className="control-hint" id={hintId}>
          {hint}
        </div>
      )}
      <p className="postal-code-selected">{selectedText}</p>
      <div className="input-group">
        <input
          disabled={disabled ? "disabled" : false}
          autoFocus={autoFocus}
          type="text"
          inputMode="numeric"
          autoComplete="postal-code"
          className="form-control"
          id={id}
          placeholder="Code postal"
          value={cpInp}
          onChange={(e) => updateSearch(e.target.value)}
          aria-describedby={describedBy}
          aria-invalid={errorMessage ? "true" : undefined}
        />
        <div className="input-group-append d-flex align-items-center">
          <i className="fa fa-search" aria-hidden="true" />
        </div>
      </div>
      <small id={errorId} role="alert" className="form-text text-danger">
        {errorMessage || null}
      </small>

      {isLoading && <Loader text="Recherche des communes" />}
      {results.length > 0 && <p id={id + "-results-title"}>Sélectionnez un lieu ci-dessous</p>}
      <ul
        className="list-group mt-3 list-unstyled"
        id="cityList"
        aria-labelledby={results.length > 0 ? id + "-results-title" : undefined}
      >
        {results.map((res, resk) => {
          const selected = res.id == value; // eslint-disable-line eqeqeq
          return (
            <li key={"pc" + resk}>
              <button
                type="button"
                className={
                  "list-group-item list-group-item-action w-100 text-left " +
                  (selected ? "active" : "")
                }
                aria-pressed={selected ? "true" : "false"}
                onClick={() => changeData(res)}
              >
                {res.postalCode} - {res.townName} {res.locationName ? res.locationName : ""}
                {selected && (
                  <i
                    style={{ lineHeight: "19px" }}
                    className="fa fa-check animated fadeInRight float-right faster"
                    aria-hidden="true"
                  />
                )}
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default PostalCode;
